module.exports = __webpack_public_path__ + "static/img/servicios_foto1.3db7432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/servicios_foto1.png
// module id = 20
// module chunks = 0